import { Star } from "lucide-react";

export default function Stars({ value = 0, size = 14, showValue = false }) {
  const full = Math.floor(value);
  const half = value - full >= 0.5;
  return (
    <span className="inline-flex items-center gap-0.5" data-testid="stars-display">
      {[0, 1, 2, 3, 4].map((i) => {
        const filled = i < full || (i === full && half);
        return (
          <Star
            key={i}
            width={size}
            height={size}
            className={filled ? "fill-orange-500 text-orange-500" : "text-slate-300"}
          />
        );
      })}
      {showValue && (
        <span className="ml-1 text-sm text-slate-700 font-medium">
          {Number(value).toFixed(1)}
        </span>
      )}
    </span>
  );
}
